export default {
    CONTACT: 'Contact',
    
    INGESTED: 'Ingested',
    INHALED: 'Inhaled',
    INJURY: 'Injury',
}